(function () {
  'use strict';

  function reveal(el) {
    if (el.dataset.nbRevealed === 'true') return;
    el.dataset.nbRevealed = 'true';
    el.classList.add('nb-timeline--revealed');
  }

  function init() {
    const els = document.querySelectorAll('[data-nb-timeline]');
    if (!els.length) return;

    // Respect reduced-motion: skip the dramatic build, just show.
    const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduced || !('IntersectionObserver' in window)) {
      els.forEach(reveal);
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            reveal(entry.target);
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -15% 0px', threshold: 0.15 }
    );

    els.forEach((el) => io.observe(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
